import React from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import { contextOfChildFormLegacy } from "../../../../shared/formObjects/application/legacy/contextOfChildFormLegacy";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function ContextOfChildComponentLegacy({ disabled, data }: any) {
  const formApi = useApiClient("ContextOfChildLegacy");
  const { id } = useApplicationContext();
  return (
    <>
      {" "}
      <BaseApplicationComponent
        formBody={contextOfChildFormLegacy}
        headerLabel="Assessment of Context of the Child"
        editPath="contextofchildLegacy"
        apiClient={formApi}
        disabled={disabled}
        data={data}
        id={id}
      />
    </>
  );
}
